export default __webpack_public_path__ + "static/media/duster-gallery-14.ce038e54.jpg";